export const useDataEntryHandlers = ({
  studentDataPoints,
  selectedDate,
  handleDelete,
  resetDataPoints,
  onClose,
  setIsDeleteDialogOpen,
}) => {
  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleConfirmDelete = (goalId) => {
    const goalCollectionID = studentDataPoints?.find(
      (dp) => dp.date === selectedDate
    )?.goalCollectionId;
    handleDelete(goalId || goalCollectionID);
    handleCloseDeleteDialog();
  };

  const handleClose = () => {
    resetDataPoints();
    onClose();
  };

  return {
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    handleConfirmDelete,
    handleClose,
  };
};
